import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';

import debounce from '../lib/debounce';
import { loadState, saveState } from '../lib/localStorage';
import rootReducer from '../reducers';
import rootSaga from '../sagas';

const { PUBLIC_URL, REACT_APP_USE_LOCAL_STORAGE: USE_LOCAL_STORAGE } = process.env;

const history = createBrowserHistory({ basename: PUBLIC_URL });

let persistedState = {};
if (USE_LOCAL_STORAGE === '1') {
  persistedState = loadState();
}

const initialiseSagaMiddleware = createSagaMiddleware();

const middlewares = applyMiddleware(routerMiddleware(history), initialiseSagaMiddleware);

const store = createStore(rootReducer(history), persistedState, composeWithDevTools(middlewares));

initialiseSagaMiddleware.run(rootSaga);

if (USE_LOCAL_STORAGE === '1') {
  store.subscribe(
    debounce(() => {
      const { countries, states, currencies } = store.getState();

      saveState({ countries, states, currencies });
    }, 300),
  );
}

export { history };
export default store;
